import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if(window.isMobile) return

        this.hoverBind = this.hover.bind(this)
        this.el.addEventListener('mouseenter', this.hoverBind)

        this.leaveBind = this.leave.bind(this)
        this.el.addEventListener('mouseleave', this.leaveBind)
    }

    hover(e) {
        e.preventDefault()

        const el = e.curTarget
        const img = this.getData('img', el)

        this.call('show',{ img }, 'Cursor')
    }

    leave() {
        this.call('hide', null, 'Cursor')
    }

    destroy() {
        if(window.isMobile) return

        this.el.removeEventListener('mouseenter', this.hoverBind)
        this.el.removeEventListener('mouseleave', this.leaveBind)
    }
}
